<template>
  <div class="container-fluid"
    :class="{ 'section-div': credential && credential.apiEncryptedUser && theme === 1, 'section-div-separator': credential && credential.apiEncryptedUser && section != 'JEWELLERY' }">
    <div v-if="visibleCategories && visibleCategories.length > 0">

      <!-- <div class="row"> -->
      <div class="row warranty-registration" v-if="section == 'JEWELLERY' && credential && credential.apiEncryptedUser">
        <div class="col-12">
          <a :href="warrantyUrl" target="_blank" class="btn btn-secondary warranty-btn">
            {{ $t("registerWarranty") }}
            <font-awesome-icon @click.stop class="info-button cursor-pointer" id="popover-target-1"
              :icon="['fas', 'info-circle']" />
          </a>
          <b-popover target="popover-target-1" triggers="hover" placement="top">
            <template #title>Garanzie</template>
            <div>{{ $t("registerWarrantyTooltip") }}</div>
          </b-popover>
        </div>
      </div>
      <div class="section-title-div" :class="[
        'section-title-div-' + theme
      ]">
        <div class="section-title-line-div" v-if="theme === 1">
          <span class="section-title-line"></span>
        </div>
        <span :class="[
          'section-title-' + theme
        ]">
          {{ $t(section.toLowerCase()) }}
        </span>
        <div class="section-title-line-div" v-if="theme === 1">
          <span class="section-title-line"></span>
        </div>
      </div>
      <div class="color-configure-descr-accessories" v-if="section == 'ACCESSORIES'">
        <span>{{
          $t("accessoriesInit")
        }}</span>
      </div>

      <div class="row justify-content-center">
        <div class="col-6 col-md-4 col-lg-3 mb-3" v-for="category in visibleCategories" :key="category.id">
          <div class="cursor-pointer" :class="[
            section + '-top-border-category',
            'top-border-category-' + theme,
          ]" v-if="category.id !== 999 ||
  //aggiungere anche per pronta consegna
  (category.id === 999 && credential && credential.apiEncryptedUser)
  " v-on:click="selectCat(category)">
            <img :src="getImage(category)" class="border-category" :class="{'pendant-category': theme == 2 && (category.id == 2 || category.id == 3)}" />
            <div v-if="theme === 2" class="col text-center cat-jewel" :class="section + '-cat-jewel'">
              <div class="cat-name">{{ category.name }}</div>
            </div>
          </div>
          <div v-if="theme === 1" class="col text-center cat-jewel-1" :class="section + '-cat-jewel'">
            <div class="cat-name">{{ category.name }}</div>
          </div>
        </div>
      </div>
      <!--<swiper ref="swiper" class="swiper swiper1 px-3" :options="swiperOptions">
        <swiper-slide v-for="category in visibleCategories" :key="category.id">
          <div
            class="cursor-pointer"
            :class="[
              theme === 1 ? 'top-border-category' : 'top-border-category-2',
              section + '-top-border-category-' + theme,
            ]"
            v-if="
              category.id !== 999 ||
              //aggiungere anche per pronta consegna
              (category.id === 999 && credential && credential.apiEncryptedUser)
            "
            v-on:click="selectCat(category)"
          >
            <img
              :src="getImage(category)"
              :class="[
                category.id === 3 || category.id === 999
                  ? 'pendant-category'
                  : '',
                theme === 1 ? 'border-category' : 'border-category-2',
              ]"
            />
            <div
              class="col text-center "
              :class="[
                theme === 1 ? 'cat-jewel' : 'cat-jewel-2',
                section + '-cat-jewel' + theme,
              ]"
            >
              <div class="cat-name">{{ category.name }}</div>
            </div>
          </div></swiper-slide
        >
        <div
          class="swiper-button-prev"
          slot="button-prev"
          v-if="credential && credential.apiEncryptedUser"
        ></div>
        <div
          class="swiper-button-next"
          slot="button-next"
          v-if="credential && credential.apiEncryptedUser"
        ></div>
        <div
          class="swiper-pagination swiper-pagination-white"
          slot="pagination"
        ></div>
      </swiper>-->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Vue from "vue";

import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  name: "ListItem",
  props: {
    section: String,
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      warrantyUrl: process.env.VUE_APP_WARRANTY_URL,
      baseImageUrl: process.env.VUE_APP_IMAGE_PATH,
      visibleCategories: [],
      swiperOptions: {
        // loop: "true",
        simulateTouch: false,
        centeredSlides: false,

        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    ...mapState({
      theme: (state) => state.config.theme,
      subCategories: (state) => state.list.subCategoriesToShow,
      categories: (state) => state.list.categories,
      stoneTypes: (state) => state.list.stoneTypes,
      credential: (state) => state.config.credential,
      locale: (state) => state.config.credential.locale,
      kit: (state) => state.config.credential.kit,
      swiper() {
        return this.$refs.swiper.$swiper;
      },
    })
  },
  mounted() {
    this.getValues();
  },
  methods: {
    ...mapActions("list", ["getListCategoriesWithCb"]),
    getImage(category) {
      return this.baseImageUrl + category.imgPath;
    },
    getValues() {
      const vm = this;
      this.getListCategoriesWithCb({
        search: "categories",
        cb: (res) => {
          vm.visibleCategories = res.filter((c) => {
            return c.toShow && c.section == vm.section.toUpperCase();
          });
          Vue.setHeight();
        },
      });
    },
    selectCat(category) {
      this.$parent.goToCategoryList(category);
    },
    prev() {
      this.$refs.swiper.$swiper.slidePrev();
    },
    next() {
      this.$refs.swiper.$swiper.slideNext();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.swiper-wrapper {
  //padding-left: 10px;
  //padding-right: 10px;
  margin-bottom: 10px;
}

.swiper-button-next,
.swiper-container-rtl,
.swiper-button-prev {
  color: var(--primary-color-1);
  font-weight: bolder;
}

.swiper-container {
  padding-bottom: 25px;
}

.swiper-button-disabled {
  opacity: 0 !important;
}

.goldsmith-swiper-button-next,
.goldsmith-swiper-container-rtl,
.goldsmith-swiper-button-prev {
  color: var(--secondary-color-1);
  font-weight: bolder;
}

.swiper-button-next {
  right: 50px;
}

.swiper-button-prev {
  left: 50px;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 50px;
}

.top-border-category-1 {
  text-align: center;
  border-radius: 5%;
  position: relative;
  margin: 10px;
  overflow: hidden;
  background-color: white;
}

.top-border-category-2 {
  text-align: center;
  box-shadow: 0px 3px 6px #00000029;
  position: relative;
  margin: 10px;
  overflow: hidden;
  background-color: white;
  margin-top: 30px;
}

.border-category {
  object-fit: cover;
  cursor: pointer;
  font-family: var(--secondary-font-family);
  width: 100%;

  &.pendant-category {
    margin-top: -60px;
    padding-bottom: 60px;
  }
}

.border-category-2 {
  object-fit: cover;
  cursor: pointer;
  font-family: var(--secondary-font-family);
  width: 100%;

}

.cat-jewel {
  font-size: 25px;
  line-height: 0.98;
  text-transform: uppercase;
  color: var(--primary-color-1);
  font-family: var(--secondary-font-family);
  position: absolute;
  margin-top: -65px;
}

.cat-jewel-1 {
  font-size: 20px;
  text-transform: uppercase;
  color: #fff;
  font-family: var(--primary-font-family);
  font-weight: 400;
  margin-bottom: 20px;
}

.cat-jewel-2 {
  font-size: 25px;
  line-height: 0.98;
  text-transform: uppercase;
  color: var(--primary-color-1);
  font-family: var(--secondary-font-family);
  position: absolute;
  margin-top: -65px;
}

.cat-name {
  width: 75%;
  margin: auto;
  text-align: center;
}

.section-title-1 {
  color: var(--secondary-color-1);
  text-transform: uppercase;
  font-size: 30px;
  font-family: var(--secondary-font-family);
  margin-bottom: 15px;
  display: table-cell;
}

.section-title-line {
  background: var(--secondary-color-1);
  height: 1px;
  width: 100%;
  content: '';
  display: block;
}

.section-title-line-div {
  width: 50%;
  display: table-cell;
  vertical-align: middle;
  padding: 0px 15px;
}

.section-title-div {
  margin-bottom: 20px;
}

.section-title-div-1 {
  padding-top: 20px;
}

.section-title-2 {
  color: var(--primary-color-1);
  font-weight: bold;
  text-transform: uppercase;
  font-size: 32px;
  font-family: EBGaramond;
  margin-bottom: 15px;
}

.categories-row {
  padding: 15px;
}

.section-div {
  background: linear-gradient(0deg, #44607E 0%, #254669 47%, #00274F 100%);
  position: relative;
  padding-top: 30px;
}

.section-div-separator {
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    border-top: 30px solid #44607E;
    border-right: 2500px solid transparent;
  }
}

@media only screen and (max-width: 1024px) {

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 25px;
  }
}

@media only screen and (max-width: 350px) {
  .cat-jewel {
    font-size: 12px !important;
  }
}

@media only screen and (max-width: 576px) {
  .cat-jewel {
    font-size: 16px;
    margin-top: -25%;
  }

  .top-border-category-1 {
    margin: 10px 0px;
  }

  .warranty-registration {

    a {
      font-size: 12px;
      margin-right: 0px !important;
      width: 100%;
    }
  }

  .top-border-category-2 {
    margin: 10px 0px;
    box-shadow: 0 0 0 5px #00000029;
  }

}

@media only screen and (min-width: 576px) and (max-width: 1200px) {
  .cat-jewel {
    font-size: 20px;
    margin-top: -55px;
  }
}

/*
@media only screen and (max-width: 576px) {
  .cat-jewel {
    font-size: 15px;
    line-height: 0.98;
    text-transform: uppercase;
    color: var(--primary-color-1);
    font-family: var(--secondary-font-family);
    margin-top: 0px;
  }
  .cat-jewel-2 {
    font-size: 15px;
    line-height: 0.98;
    text-transform: uppercase;
    color: var(--primary-color-1);
    font-family: var(--secondary-font-family);
    margin-top: 0px;
  }
  .top-border-category {
    text-align: center;
    box-shadow: none;
    position: relative;
    border-radius: 50%;
    background-color: white;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    margin-left: 0px;
  }
  .top-border-category-2 {
    text-align: center;
    box-shadow: none;
    position: relative;
    box-shadow: 0px 3px 6px #00000029;
    background-color: white;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    margin-left: 0px;
  }
  .border-category {
    object-fit: cover;
    cursor: pointer;
    border-radius: 50%;
    box-shadow: none;
    font-family: var(--secondary-font-family);
    width: 70%;
    &.pendant-category {
      margin-top: 0px;
      padding-bottom: 0px;
    }
  }
}*/
.border-category-2 {
  object-fit: cover;
  cursor: pointer;
  box-shadow: none;
  font-family: var(--secondary-font-family);
  width: 70%;
}

.color-configure-descr-accessories {
  color: #fff;
  font-weight: 500;
  font-size: 20px;
  padding: 20px;
  font-family: var(--font-family);
  vertical-align: middle;
}

.warranty-registration {
  text-align: right;

  a {
    margin-right: 10px;
  }
}

.warranty-btn {
  background-color: var(--secondary-color-1) !important;
  color: var(--primary-color-1) !important;
}
</style>
